import { createStore, compose, combineReducers, applyMiddleware, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import { reducers } from './index';
import socketMiddleware from '../middlerware/socket';

const isDevelopment = process.env.NODE_ENV === 'development';

const loggerMiddleware = createLogger({
    collapsed: true,
});

const enhancer = compose(
    isDevelopment ? applyMiddleware(thunkMiddleware, socketMiddleware, loggerMiddleware)
        :
        applyMiddleware(thunkMiddleware, socketMiddleware)
);

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export function configStore(): Store<any> {
    return createStore(combineReducers(reducers), composeEnhancers(enhancer));
}



// WEBPACK FOOTER //
// ./src/reducers/configStore.ts